import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { MODES } from 'AppTheme/constants';
import { getMode } from 'AppTheme/helpers';
const scrollStyles = {
    [MODES.DARK]: {
        color: '#646464',
        thumb: '#666', // $color-dark-blue  -- slack #747e7b
        track: '#0e1f2a'
    },
    [MODES.LIGHT]: {
        color: '#f7f7f7',
        thumb: '#7b807f', // '#dcdcdc' -- slack #7b807f
        track: '#EAEAEA'
    }
};
const getScrollColor = (mode) => scrollStyles[mode].color;
const getScrollColorThumb = (mode) => scrollStyles[mode].thumb;
const getScrollColorTrack = (mode) => scrollStyles[mode].track;
const GlobalStyle = createGlobalStyle `
html {
  scrollbar-face-color: ${(props) => getScrollColor(getMode(props))};
  scrollbar-base-color:${(props) => getScrollColor(getMode(props))};
  scrollbar-3dlight-color: ${(props) => getScrollColor(getMode(props))};
  scrollbar-highlight-color: ${(props) => getScrollColor(getMode(props))};
  scrollbar-track-color: ${(props) => getScrollColorTrack(getMode(props))};
  scrollbar-arrow-color: ${(props) => getScrollColorTrack(getMode(props))};
  scrollbar-shadow-color: ${(props) => getScrollColor(getMode(props))};
  scrollbar-dark-shadow-color: ${(props) => getScrollColor(getMode(props))};
}

::-webkit-scrollbar {
  width: 8px;
  height: 3px;
}
::-webkit-scrollbar-button {
  background-color: ${(props) => getScrollColorThumb(getMode(props))};
}
::-webkit-scrollbar-track {
  background-color: ${(props) => getScrollColor(getMode(props))};
}
::-webkit-scrollbar-track-piece {
  background-color: ${(props) => getScrollColorTrack(getMode(props))};
}
::-webkit-scrollbar-thumb {
  height: 50px;
  background-color : ${(props) => getScrollColorThumb(getMode(props))};
  border-radius: 3px;
}
::-webkit-scrollbar-corner {
  background-color: ${(props) => getScrollColor(getMode(props))};
}
::-webkit-resizer {
  background-color: ${(props) => getScrollColorThumb(getMode(props))};
}

body {
  margin: 0;
  padding: 0 !important;
  font-family: 'Equinor' !important;
}

a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
`;
const CSSCustomGlobals = () => React.createElement(GlobalStyle, null);
export default CSSCustomGlobals;
